import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import missionImg from "../../images/©Antoine_Meyssonnier-4628.jpg";

const MissionHeroSection = () => {
  const path = useLocation();
  const [title, setTitle] = useState("Missions & Services");
  const [desc, setDesc] = useState("");
  useEffect(() => {
    switch (path.search) {
      case "?water":
        setTitle("Missions & Services");
        setDesc("");
        break;
      case "?quality-control":
        setTitle("Contrôle et qualité");
        setDesc("");
        break;

      case "?issue":
        setTitle("Maîtrise des fuites");
        setDesc("");
        break;

      default:
        break;
    }
  }, [path.search]);

  return (
    <div className="">
      <section
        className="p-10 text-center lg:p-32 bg-black/70 bg-blend-overlay "
        style={{
          backgroundImage: `url(${missionImg})`,
          backgroundSize: "cover",
        }}
      >
        <h1 className="text-2xl font-bold text-center text-white md:text-4xl lg:text-7xl">
          {title}
        </h1>

        <div className="flex justify-center mt-3">
          <p className="w-full text-white ">{desc}</p>
        </div>
      </section>
    </div>
  );
};

export default MissionHeroSection;
